import { render, staticRenderFns } from "./GreetingArea.vue?vue&type=template&id=5c57362e&scoped=true"
import script from "./GreetingArea.vue?vue&type=script&lang=js"
export * from "./GreetingArea.vue?vue&type=script&lang=js"
import style0 from "./GreetingArea.vue?vue&type=style&index=0&id=5c57362e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c57362e",
  null
  
)

export default component.exports